'use client';

import { useEffect } from 'react';
import { signInAction } from './actions';
import styles from './page.module.css';

export default function AutoSignIn() {
  useEffect(() => {
    signInAction();
  }, []);

  return <div className={styles.page}>Signing in...</div>;
}
